import React, { useState } from 'react';
import { API, authFetch } from '../App';

const BookConsultation = ({ onBooked }) => {
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleBook = async (e) => {
        e.preventDefault();
        if (!selectedDate || !selectedTime) {
            setError("Please select both a date and time.");
            return;
        }

        setLoading(true);
        setError(null);
        
        try {
            // Convert local date and time to ISO format in UTC
            const localDateTime = new Date(`${selectedDate}T${selectedTime}`);
            const scheduled_time = localDateTime.toISOString();

            const res = await authFetch(`${API}/consultations/book`, { 
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ scheduled_time })
            });
            
            const data = await res.json();
            
            if (!res.ok) {
                throw new Error(data.detail || "Failed to book consultation. Please try again.");
            }
            
            if (onBooked) {
                onBooked(data);
            }
        } catch (err) {
            setError(err.message || "Failed to book consultation. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // Get today's date for the min attribute
    const today = new Date().toISOString().split('T')[0];

    return (
        <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-6 mb-8">
            <h3 className="text-lg font-semibold text-slate-800 mb-4">Book a Consultation</h3>
            <p className="text-sm text-slate-500 mb-6">Schedule a meeting with your dedicated CA desk. A Google Meet link will be automatically generated.</p>
            
            {error && (
                <div className="bg-red-50 text-red-600 p-3 rounded-md text-sm mb-4">
                    {error}
                </div>
            )}

            <form onSubmit={handleBook} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Date</label>
                        <input 
                            type="date" 
                            className="w-full rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm p-2 border"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            min={today}
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Time</label>
                        <input 
                            type="time" 
                            className="w-full rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm p-2 border"
                            value={selectedTime}
                            onChange={(e) => setSelectedTime(e.target.value)}
                            required
                        />
                    </div>
                </div>
                
                <div className="flex justify-end">
                    <button 
                        type="submit" 
                        disabled={loading}
                        className="bg-[#145886] hover:bg-[#104b72] text-white px-4 py-2 rounded-md font-medium text-sm transition-colors disabled:opacity-50"
                    >
                        {loading ? 'Scheduling...' : 'Book Meeting'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default BookConsultation;
